import styled from 'styled-components';
import { FontSize, FontWeight, device, spacing } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .error {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  .text {
    max-width: 300px;
  }
`;

export const PostWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PostCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 3;
  height: ${spacing.input.height};
  gap: 4px;
  border-radius: 8px;
  padding: 8px;
  background-color: ${({ theme }) => theme.neutral_200};

  @media (max-width: ${device.tablet}px) {
    width: 100%;
    flex: auto;
  }
`;

export const PostInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`;

export const ButtonLink = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${FontSize.font12};
  font-weight: ${FontWeight.bold};
  background-color: transparent;
  color: ${({ theme }) => theme.primary_300};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }
`;
